import { gql } from '@apollo/client';
// local imports
import { API_ADMIN_REPORT } from '../config/api';

export const ADMIN_TARGET_JOBS_QUERY = gql`
  query ARTargetJobs(
    $report_id: Int!
    $offset: Int
    $limit: Int
  ) {
    arTargetJobs(
      report_id: $report_id,
      offset: $offset,
      limit: $limit
    )
    @rest(
      type: "ARTargetJobsPayload",
      path: "${API_ADMIN_REPORT}?limit={args.limit}&offset={args.offset}"
    ) {
      count
      results {
        code
        title
        count
      }
    }
  }
`;
